// extracted by mini-css-extract-plugin
export var active = "Exchange-module--active--baa43";
export var blackBtn = "Exchange-module--blackBtn--151d9";
export var btnContainer = "Exchange-module--btnContainer--ab694";
export var creditCardContainer = "Exchange-module--creditCardContainer--1d4ed";
export var description = "Exchange-module--description--be766";
export var desktopButton = "Exchange-module--desktopButton--70c55";
export var exchangeContainer = "Exchange-module--exchangeContainer--ee8d8";
export var exchanges = "Exchange-module--exchanges--6edea";
export var exchangesContainer = "Exchange-module--exchangesContainer--9d7d3";
export var mobileButton = "Exchange-module--mobileButton--3623d";
export var sectionModal = "Exchange-module--sectionModal--2347f";
export var start = "Exchange-module--start--b95af";
export var tab = "Exchange-module--tab--e061c";
export var tabs = "Exchange-module--tabs--a300a";
export var text = "Exchange-module--text--47341";